module.exports = __webpack_public_path__ + "img/wheel1.e187ea2c.png";